/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_New_Invoice_WarningInputs */

const en_admin_external_booking_new_invoice_warning = /** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating this booking will generate an invoice, which will be emailed to the visitor for payment.`)
};

/** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */
const de_admin_external_booking_new_invoice_warning = en_admin_external_booking_new_invoice_warning;

/** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */
const es_admin_external_booking_new_invoice_warning = en_admin_external_booking_new_invoice_warning;

/** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */
const fr_admin_external_booking_new_invoice_warning = en_admin_external_booking_new_invoice_warning;

/** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */
const it_admin_external_booking_new_invoice_warning = en_admin_external_booking_new_invoice_warning;

/** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */
const pt_br2_admin_external_booking_new_invoice_warning = en_admin_external_booking_new_invoice_warning;

/** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */
const pl_admin_external_booking_new_invoice_warning = en_admin_external_booking_new_invoice_warning;

/** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */
const hu_admin_external_booking_new_invoice_warning = en_admin_external_booking_new_invoice_warning;

/** @type {(inputs: Admin_External_Booking_New_Invoice_WarningInputs) => LocalizedString} */
const ro_admin_external_booking_new_invoice_warning = en_admin_external_booking_new_invoice_warning;

/**
* | output |
* | --- |
* | "Creating this booking will generate an invoice, which will be emailed to the visitor for payment." |
*
* @param {Admin_External_Booking_New_Invoice_WarningInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_new_invoice_warning = /** @type {((inputs?: Admin_External_Booking_New_Invoice_WarningInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_New_Invoice_WarningInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_new_invoice_warning(inputs)
	if (locale === "de") return de_admin_external_booking_new_invoice_warning(inputs)
	if (locale === "es") return es_admin_external_booking_new_invoice_warning(inputs)
	if (locale === "fr") return fr_admin_external_booking_new_invoice_warning(inputs)
	if (locale === "it") return it_admin_external_booking_new_invoice_warning(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_new_invoice_warning(inputs)
	if (locale === "pl") return pl_admin_external_booking_new_invoice_warning(inputs)
	if (locale === "hu") return hu_admin_external_booking_new_invoice_warning(inputs)
	return ro_admin_external_booking_new_invoice_warning(inputs)
});
export { admin_external_booking_new_invoice_warning as "admin.external_booking_new.invoice_warning" }